// The placeholder is substituted by nginx at container start (see `sub_filter` in nginx.conf),
// which is how one build serves every environment.
const apiUrl = process.env.REACT_APP_API_URL || "https://bo-api.assetsview.io";

const config = {
  REACT_APP_API_URL: apiUrl,
  /**
   * The SignalR quotes hub. `.env.example` has always declared this and nothing read it — the hub
   * url was hardcoded in `useSocket`. The fallback derives it from the api url so deployments
   * that only substitute `REACT_APP_API_URL` at runtime keep working untouched.
   */
  REACT_APP_SOCKET_URL: process.env.REACT_APP_SOCKET_URL || `${apiUrl}/quotes`,
};

export default config;
